import { AxiosError } from 'axios'

export const logoutInterceptorCreator = (logoutCallback: () => any) => (error: AxiosError) => {
  if (error.response?.status === 401) logoutCallback()
  return Promise.reject(error)
}
